import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserService } from '../services/user/user.service';

/**
 * Guard that protects routes that should only be accessible when the user is NOT linked.
 * Redirects to /home if the user is already linked.
 * Used for the /user/link route.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const userNotLinkedGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  // In development mode, skip the check (similar to app.component)
  if (!environment.production) {
    return true;
  }

  // Check if user is linked by attempting to get current user
  return userService.getCurrentUser().pipe(
    map(() => {
      // User is linked, redirect to home
      router.navigate(['/home']);
      return false;
    }),
    catchError(() => {
      // User is not linked, allow access to link page
      return of(true);
    }),
  );
};
